import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const InitialPaymentCalculatorWrapper = styled.div`
    padding: ${getPurpurSpacing('300')};
    border: 1px solid ${getPurpurColor('gray100')};
    background: ${getPurpurColor('gray50')};
    font-size: ${getPurpurTypography('scale75')};
`;

export const CalculatorPriceRange = styled.div`
    display: flex;
    place-content: space-between;
`;
